module.exports = __webpack_public_path__ + "img/SUBWAY.eeb3c56c.svg";